<template>
  <div
    class="modal fade fixed-end"
    tabindex="-1"
    role="dialog"
  >
    <div
      class="modal-dialog modal-dialog-vertical dw-md-8 dw-lg-6 dw-xl-5"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="drawer-title">{{ localApproval.id ? 'Update Approval' : 'Create Approval' }}</h2>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <div class="row">
            <div class="col-6 mb-3">
              <label class="control-label">Date</label>
              <input
                name="date"
                v-model="localApproval.date"
                type="date"
                class="form-control"
                data-vv-validate-on="input|blur"
                data-vv-as="date"
                v-validate="'required'"
              />
              <help-block field="date" />
            </div>

            <div class="col-6 mb-3">
              <label class="control-label">Amount</label>
              <div class="input-group">
                <input
                  name="amount"
                  v-model="localApproval.amount"
                  type="number"
                  class="form-control"
                  data-vv-validate-on="input|blur"
                  data-vv-as="amount"
                  v-validate="'required'"
                />
                <span class="input-group-text">hrs</span>
              </div>
              <help-block field="amount" />
            </div>
          </div>

          <div class="mb-3">
            <label class="control-label">Recorded By</label>
            <div class="input-group">
              <span class="input-group-text">
                <i class="fal fa-fw fa-user"></i>
              </span>
              <multiselect
                :show-labels="false"
                v-model="user"
                :options="users"
                label="name"
                track-by="id"
                placeholder="Select User"
                v-validate="'required'"
                data-vv-name="user"
                @select="userSelected"
              ></multiselect>
            </div>
            <help-block field="user" />
          </div>

          <div class="mb-3">
            <label class="control-label">Note</label>
            <textarea
              name="note"
              rows="6"
              v-model="localApproval.note"
              class="form-control"
              data-vv-validate-on="input|blur"
              data-vv-as="note"
              v-validate="'required'"
            ></textarea>
            <help-block field="note" />
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
            <c-button @click="handleSaveApproval" class="btn btn-rounded btn-primary">Save</c-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.invalid-feedback {
  display: inline-block;
}
</style>

<script>
import { mapActions, mapState } from 'vuex'
import { notify } from 'utils'
import { cloneDeep } from 'lodash'
import Multiselect from 'vue-multiselect'
import { CModal } from '@chameleon/chameleon-vue'

export default {
  $_veeValidate: {
    validator: 'new' // give me my own validator scope.
  },

  extends: CModal,

  components: {
    Multiselect
  },

  data () {
    return {
      approval: {},
      localApproval: {},
      user: null
    }
  },

  mounted () {
    this.getUsers()

    this.addEventListener('open', () => {
      this.localApproval = cloneDeep(this.approval)

      if (this.localApproval.id) {
        this.user = this.localApproval.user
      } else {
        // Default to logged in user
        this.user = { id: this.authorized.id, name: this.authorized.name }
        this.localApproval.user_id = this.authorized.id
      }
    })
  },

  computed: {
    ...mapState('users', ['users']),
    ...mapState('user', ['authorized'])
  },

  methods: {
    ...mapActions('budget/approvals', ['addSingle', 'updateSingle']),
    ...mapActions('users', ['getUsers']),

    userSelected (selected) {
      this.localApproval.user_id = selected.id
    },

    async handleSaveApproval () {
      if (!(await this._validate())) {
        notify.error('Form validation failed, please check your inputs and try again.')
        return Promise.reject()
      }

      const request = this.localApproval.id
        ? this.updateSingle({ id: this.localApproval.id, payload: this.localApproval })
        : this.addSingle(this.localApproval)

      return request.then(() => {
        notify.success('Approval successfully saved.')
        this.$emit('saved')
        this.close()
      })
    }
  }
}
</script>
